module.exports = __webpack_public_path__ + "static/media/fuelman-card-mobile.892dbae2.svg";